"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkConsumerDobOver21 = void 0;
const types_1 = require("../types/types");
/**
 * checkConsumerDobOver21 function for checking consumer age
 *
 * @param dob - date of birth
 * @returns bool - whether the consumer is greater or smaller than 21 years old
 */
const checkConsumerDobOver21 = (dob) => {
    if (!dob ||
        (dob.day === types_1.initialDOB.day &&
            dob.month === types_1.initialDOB.month &&
            dob.year === types_1.initialDOB.year)) {
        return false;
    }
    const currentDate = new Date();
    const birthDate = new Date(dob.year, dob.month - 1, dob.day); // month is 0-based in JavaScript Date object
    // Calculate the difference in years
    const ageDifferenceInMilliseconds = currentDate.getTime() - birthDate.getTime();
    const ageDifferenceInYears = ageDifferenceInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
    return ageDifferenceInYears >= 21;
};
exports.checkConsumerDobOver21 = checkConsumerDobOver21;
